<template>
  <div id="app">
    <h1 style="text-align: center;">世界各国和地区名称代码</h1>
    <div>
      <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="504"
        style="border-collapse: collapse; table-layout: fixed"
      >
        <col span="7" style="width: 54pt" />
        <tr id="r0">
          <td>序号</td>
          <td>中文简称</td>
          <td>英文简称</td>
          <td>英文全称</td>
          <td>两字母代码</td>
          <td>三字母代码</td>
          <td>数字代码</td>
        </tr>
        <tr id="r1">
          <td style="text-align: center">1</td>
          <td class="x24">阿富汗</td>
          <td>Afghanistan</td>
          <td style="overflow: hidden">the Islamic RepublicofAfghanistan</td>
          <td>AF</td>
          <td>AFG</td>
          <td style="text-align: center">4</td>
        </tr>
        <tr id="r2">
          <td style="text-align: center">2</td>
          <td>奥兰群岛</td>
          <td>AlandIslands</td>
          <td>/</td>
          <td>AX</td>
          <td>ALA</td>
          <td style="text-align: center">248</td>
        </tr>
        <tr id="r3">
          <td style="text-align: center">3</td>
          <td>阿尔巴尼亚</td>
          <td>Albania</td>
          <td style="overflow: hidden">theRepublicofAlbania</td>
          <td>AL</td>
          <td>ALB</td>
          <td style="text-align: center">8</td>
        </tr>
        <tr style="height: 48.75pt" id="r4">
          <td style="text-align: center; height: 45.75pt">4</td>
          <td>阿尔及利亚</td>
          <td>Algeria</td>
          <td style="overflow: hidden">
            thePeople'sDemocraticRepublicofAlgeria
          </td>
          <td>DZ</td>
          <td>DZA</td>
          <td style="text-align: center">12</td>
        </tr>
        <tr id="r5">
          <td style="text-align: center">5</td>
          <td>美属萨摩亚</td>
          <td style="overflow: hidden">AmericanSamoa</td>
          <td>/</td>
          <td>AS</td>
          <td>ASM</td>
          <td style="text-align: center">16</td>
        </tr>
        <tr id="r6">
          <td style="text-align: center">6</td>
          <td>安道尔</td>
          <td>Andorra</td>
          <td style="overflow: hidden">thePrincipalityofAndorra</td>
          <td>AD</td>
          <td>AND</td>
          <td style="text-align: center">20</td>
        </tr>
        <tr id="r7">
          <td style="text-align: center">7</td>
          <td>安哥拉</td>
          <td>Angola</td>
          <td style="overflow: hidden">theRepublicofAngola</td>
          <td>AO</td>
          <td>AGO</td>
          <td style="text-align: center">24</td>
        </tr>
        <tr id="r8">
          <td style="text-align: center; height: 11.25pt">8</td>
          <td>安圭拉</td>
          <td>Anguilla</td>
          <td>/</td>
          <td>AI</td>
          <td>AIA</td>
          <td style="text-align: center">660</td>
        </tr>
        <tr id="r9">
          <td style="text-align: center; height: 11.25pt">9</td>
          <td>南极洲</td>
          <td>Antarctica</td>
          <td>/</td>
          <td>AQ</td>
          <td>ATA</td>
          <td style="text-align: center">10</td>
        </tr>
        <tr id="r10">
          <td style="text-align: center">10</td>
          <td>安提瓜和巴布达</td>
          <td style="overflow: hidden">AntiguaandBarbuda</td>
          <td>/</td>
          <td>AG</td>
          <td>ATG</td>
          <td style="text-align: center">28</td>
        </tr>
        <tr id="r11">
          <td style="text-align: center">11</td>
          <td>阿根廷</td>
          <td>Argentina</td>
          <td style="overflow: hidden">theArgentineRepublic</td>
          <td>AR</td>
          <td>ARG</td>
          <td style="text-align: center">32</td>
        </tr>
        <tr id="r12">
          <td style="text-align: center">12</td>
          <td>亚美尼亚</td>
          <td>Armenia</td>
          <td style="overflow: hidden">theRepublicofArmenia</td>
          <td>AM</td>
          <td>ARM</td>
          <td style="text-align: center">51</td>
        </tr>
        <tr id="r13">
          <td style="text-align: center; height: 11.25pt">13</td>
          <td>阿鲁巴</td>
          <td>Aruba</td>
          <td>/</td>
          <td>AW</td>
          <td>ABW</td>
          <td style="text-align: center">533</td>
        </tr>
        <tr id="r14">
          <td style="text-align: center; height: 11.25pt">14</td>
          <td>澳大利亚</td>
          <td>Australia</td>
          <td>/</td>
          <td>AU</td>
          <td>AUS</td>
          <td style="text-align: center">36</td>
        </tr>
        <tr id="r15">
          <td style="text-align: center">15</td>
          <td>奥地利</td>
          <td>Austria</td>
          <td style="overflow: hidden">theRepublicofAustria</td>
          <td>AT</td>
          <td>AUT</td>
          <td style="text-align: center">40</td>
        </tr>
        <tr id="r16">
          <td style="text-align: center">16</td>
          <td>阿塞拜疆</td>
          <td>Azerbaijan</td>
          <td style="overflow: hidden">theRepublicofAzerbaijan</td>
          <td>AZ</td>
          <td>AZE</td>
          <td style="text-align: center">31</td>
        </tr>
        <tr id="r17">
          <td style="text-align: center">17</td>
          <td>巴哈马</td>
          <td style="overflow: hidden">Bahamas(The)</td>
          <td style="overflow: hidden">theCommonwealthofTheBahamas</td>
          <td>BS</td>
          <td>BHS</td>
          <td style="text-align: center">44</td>
        </tr>
        <tr id="r18">
          <td style="text-align: center">18</td>
          <td>巴林</td>
          <td>Bahrain</td>
          <td style="overflow: hidden">theKingdomofBahrain</td>
          <td>BH</td>
          <td>BHR</td>
          <td style="text-align: center">48</td>
        </tr>
        <tr id="r19">
          <td style="text-align: center">19</td>
          <td>孟加拉国</td>
          <td>Bangladesh</td>
          <td style="overflow: hidden">thePeople'sRepublicofBangladesh</td>
          <td>BD</td>
          <td>BGD</td>
          <td style="text-align: center">50</td>
        </tr>
        <tr id="r20">
          <td style="text-align: center; height: 11.25pt">20</td>
          <td>巴巴多斯</td>
          <td>Barbados</td>
          <td>/</td>
          <td>BB</td>
          <td>BRB</td>
          <td style="text-align: center">52</td>
        </tr>
        <tr id="r21">
          <td style="text-align: center">21</td>
          <td>白俄罗斯</td>
          <td>Belarus</td>
          <td style="overflow: hidden">theRepublicofBelarus</td>
          <td>BY</td>
          <td>BLR</td>
          <td style="text-align: center">112</td>
        </tr>
        <tr id="r22">
          <td style="text-align: center">22</td>
          <td>比利时</td>
          <td>Belgium</td>
          <td style="overflow: hidden">theKingdomofBelgium</td>
          <td>BE</td>
          <td>BEL</td>
          <td style="text-align: center">56</td>
        </tr>
        <tr id="r23">
          <td style="text-align: center; height: 11.25pt">23</td>
          <td>伯利兹</td>
          <td>Belize</td>
          <td>/</td>
          <td>BZ</td>
          <td>BLZ</td>
          <td style="text-align: center">84</td>
        </tr>
        <tr id="r24">
          <td style="text-align: center">24</td>
          <td>贝宁</td>
          <td>Benin</td>
          <td style="overflow: hidden">theRepublicofBenin</td>
          <td>BJ</td>
          <td>BEN</td>
          <td style="text-align: center">204</td>
        </tr>
        <tr id="r25">
          <td style="text-align: center; height: 11.25pt">25</td>
          <td>百慕大</td>
          <td>Bermuda</td>
          <td>/</td>
          <td>BM</td>
          <td>BMU</td>
          <td style="text-align: center">60</td>
        </tr>
        <tr id="r26">
          <td style="text-align: center">26</td>
          <td>不丹</td>
          <td>Bhutan</td>
          <td style="overflow: hidden">theKingdomofBhutan</td>
          <td>BT</td>
          <td>BTN</td>
          <td style="text-align: center">64</td>
        </tr>
        <tr id="r27">
          <td style="text-align: center">27</td>
          <td>玻利维亚</td>
          <td>Bolivia</td>
          <td style="overflow: hidden">theRepublicofBolivia</td>
          <td>BO</td>
          <td>BOL</td>
          <td style="text-align: center">68</td>
        </tr>
        <tr id="r28">
          <td style="text-align: center">28</td>
          <td>波黑</td>
          <td style="overflow: hidden">BosniaandHerzegovina</td>
          <td>/</td>
          <td>BA</td>
          <td>BIH</td>
          <td style="text-align: center">70</td>
        </tr>
        <tr id="r29">
          <td style="text-align: center">29</td>
          <td>博茨瓦纳</td>
          <td>Botswana</td>
          <td style="overflow: hidden">theRepublicofBotswana</td>
          <td>BW</td>
          <td>BWA</td>
          <td style="text-align: center">72</td>
        </tr>
        <tr id="r30">
          <td style="text-align: center">30</td>
          <td>布维岛</td>
          <td>BouvetIsland</td>
          <td>/</td>
          <td>BV</td>
          <td>BVT</td>
          <td style="text-align: center">74</td>
        </tr>
        <tr id="r31">
          <td style="text-align: center">31</td>
          <td>巴西</td>
          <td>Brazil</td>
          <td style="overflow: hidden">theFederativeRepublicofBrazil</td>
          <td>BR</td>
          <td>BRA</td>
          <td style="text-align: center">76</td>
        </tr>
        <tr id="r32">
          <td style="text-align: center">32</td>
          <td>英属印度洋领地</td>
          <td style="overflow: hidden">BritishIndianOceanTerritory(the)</td>
          <td>/</td>
          <td>IO</td>
          <td>IOT</td>
          <td style="text-align: center">86</td>
        </tr>
        <tr id="r33">
          <td style="text-align: center">33</td>
          <td>文莱</td>
          <td style="overflow: hidden">BruneiDarussalam</td>
          <td>/</td>
          <td>BN</td>
          <td>BRN</td>
          <td style="text-align: center">96</td>
        </tr>
        <tr id="r34">
          <td style="text-align: center">34</td>
          <td>保加利亚</td>
          <td>Bulgaria</td>
          <td style="overflow: hidden">theRepublicofBulgaria</td>
          <td>BG</td>
          <td>BGR</td>
          <td style="text-align: center">100</td>
        </tr>
        <tr id="r35">
          <td style="text-align: center">35</td>
          <td>布基纳法索</td>
          <td>BurkinaFaso</td>
          <td>BurkinaFaso</td>
          <td>BF</td>
          <td>BFA</td>
          <td style="text-align: center">854</td>
        </tr>
        <tr id="r36">
          <td style="text-align: center">36</td>
          <td>布隆迪</td>
          <td>Burundi</td>
          <td style="overflow: hidden">theRepublicofBurundi</td>
          <td>BI</td>
          <td>BDI</td>
          <td style="text-align: center">108</td>
        </tr>
        <tr id="r37">
          <td style="text-align: center">37</td>
          <td>柬埔寨</td>
          <td>Cambodia</td>
          <td style="overflow: hidden">theKingdomofCambodia</td>
          <td>KH</td>
          <td>KHM</td>
          <td style="text-align: center">116</td>
        </tr>
        <tr id="r38">
          <td style="text-align: center">38</td>
          <td>喀麦隆</td>
          <td>Cameroon</td>
          <td style="overflow: hidden">theRepublicofCameroon</td>
          <td>CM</td>
          <td>CMR</td>
          <td style="text-align: center">120</td>
        </tr>
        <tr id="r39">
          <td style="text-align: center; height: 11.25pt">39</td>
          <td>加拿大</td>
          <td>Canada</td>
          <td>/</td>
          <td>CA</td>
          <td>CAN</td>
          <td style="text-align: center">124</td>
        </tr>
        <tr id="r40">
          <td style="text-align: center">40</td>
          <td>佛得角</td>
          <td>CapeVerde</td>
          <td style="overflow: hidden">theRepublicofCapeVerde</td>
          <td>CV</td>
          <td>CPV</td>
          <td style="text-align: center">132</td>
        </tr>
        <tr id="r41">
          <td style="text-align: center">41</td>
          <td>开曼群岛</td>
          <td style="overflow: hidden">CaymanIslands(the)</td>
          <td>/</td>
          <td>KY</td>
          <td>CYM</td>
          <td style="text-align: center">136</td>
        </tr>
        <tr id="r42">
          <td style="text-align: center">42</td>
          <td>中非</td>
          <td style="overflow: hidden">CentralAfricanRepublic(the)</td>
          <td style="overflow: hidden">theCentralAfricanRepublic</td>
          <td>CF</td>
          <td>CAF</td>
          <td style="text-align: center">140</td>
        </tr>
        <tr id="r43">
          <td style="text-align: center">43</td>
          <td>乍得</td>
          <td>Chad</td>
          <td style="overflow: hidden">theRepublicofChad</td>
          <td>TD</td>
          <td>TCD</td>
          <td style="text-align: center">148</td>
        </tr>
        <tr id="r44">
          <td style="text-align: center">44</td>
          <td>智利</td>
          <td>Chile</td>
          <td style="overflow: hidden">theRepublicofChile</td>
          <td>CL</td>
          <td>CHL</td>
          <td style="text-align: center">152</td>
        </tr>
        <tr id="r45">
          <td style="text-align: center">45</td>
          <td>中国</td>
          <td>China</td>
          <td style="overflow: hidden">thePeople'sRepublicofChina</td>
          <td>CN</td>
          <td>CHN</td>
          <td style="text-align: center">156</td>
        </tr>
        <tr id="r46">
          <td style="text-align: center">46</td>
          <td>圣诞岛</td>
          <td style="overflow: hidden">ChristmasIsland</td>
          <td>/</td>
          <td>CX</td>
          <td>CXR</td>
          <td style="text-align: center">162</td>
        </tr>
        <tr id="r47">
          <td style="text-align: center">47</td>
          <td style="overflow: hidden">科科斯（基林）群岛</td>
          <td style="overflow: hidden">Cocos(Keeling)Islands(the)</td>
          <td>/</td>
          <td>CC</td>
          <td>CCK</td>
          <td style="text-align: center">166</td>
        </tr>
        <tr id="r48">
          <td style="text-align: center">48</td>
          <td>哥伦比亚</td>
          <td>Colombia</td>
          <td style="overflow: hidden">theRepublicofColombia</td>
          <td>CO</td>
          <td>COL</td>
          <td style="text-align: center">170</td>
        </tr>
        <tr id="r49">
          <td style="text-align: center">49</td>
          <td>科摩罗</td>
          <td>Comoros</td>
          <td style="overflow: hidden">theUnionoftheComoros</td>
          <td>KM</td>
          <td>COM</td>
          <td style="text-align: center">174</td>
        </tr>
        <tr id="r50">
          <td style="text-align: center">50</td>
          <td>刚果（布）</td>
          <td>Congo</td>
          <td style="overflow: hidden">theRepublicoftheCongo</td>
          <td>CG</td>
          <td>COG</td>
          <td style="text-align: center">178</td>
        </tr>
        <tr style="height: 48.75pt" id="r51">
          <td style="text-align: center; height: 45.75pt">51</td>
          <td>刚果（金）</td>
          <td style="overflow: hidden">Congo(theDemocraticRepublicofthe)</td>
          <td style="overflow: hidden">theDemocraticRepublicoftheCongo</td>
          <td>CD</td>
          <td>COD</td>
          <td style="text-align: center">180</td>
        </tr>
        <tr id="r52">
          <td style="text-align: center">52</td>
          <td>库克群岛</td>
          <td style="overflow: hidden">CookIslands(the)</td>
          <td>/</td>
          <td>CK</td>
          <td>COK</td>
          <td style="text-align: center">184</td>
        </tr>
        <tr id="r53">
          <td style="text-align: center">53</td>
          <td>哥斯达黎加</td>
          <td>CostaRica</td>
          <td style="overflow: hidden">theRepublicofCostaRica</td>
          <td>CR</td>
          <td>CRI</td>
          <td style="text-align: center">188</td>
        </tr>
        <tr id="r54">
          <td style="text-align: center">54</td>
          <td>科特迪瓦</td>
          <td>Côted'Ivoire</td>
          <td style="overflow: hidden">theRepublicofCôted'Ivoire</td>
          <td>CI</td>
          <td>CIV</td>
          <td style="text-align: center">384</td>
        </tr>
        <tr id="r55">
          <td style="text-align: center">55</td>
          <td>克罗地亚</td>
          <td>Croatia</td>
          <td style="overflow: hidden">theRepublicofCroatia</td>
          <td>HR</td>
          <td>HRV</td>
          <td style="text-align: center">191</td>
        </tr>
        <tr id="r56">
          <td style="text-align: center">56</td>
          <td>古巴</td>
          <td>Cuba</td>
          <td style="overflow: hidden">theRepublicofCuba</td>
          <td>CU</td>
          <td>CUB</td>
          <td style="text-align: center">192</td>
        </tr>
        <tr id="r57">
          <td style="text-align: center">57</td>
          <td>塞浦路斯</td>
          <td>Cyprus</td>
          <td style="overflow: hidden">theRepublicofCyprus</td>
          <td>CY</td>
          <td>CYP</td>
          <td style="text-align: center">196</td>
        </tr>
        <tr id="r58">
          <td style="text-align: center">58</td>
          <td>捷克</td>
          <td style="overflow: hidden">CzechRepublic(the)</td>
          <td style="overflow: hidden">theCzechRepublic</td>
          <td>CZ</td>
          <td>CZE</td>
          <td style="text-align: center">203</td>
        </tr>
        <tr id="r59">
          <td style="text-align: center">59</td>
          <td>丹麦</td>
          <td>Denmark</td>
          <td style="overflow: hidden">theKingdomofDenmark</td>
          <td>DK</td>
          <td>DNK</td>
          <td style="text-align: center">208</td>
        </tr>
        <tr id="r60">
          <td style="text-align: center">60</td>
          <td>吉布提</td>
          <td>Djibouti</td>
          <td style="overflow: hidden">theRepublicofDjibouti</td>
          <td>DJ</td>
          <td>DJI</td>
          <td style="text-align: center">262</td>
        </tr>
        <tr id="r61">
          <td style="text-align: center">61</td>
          <td>多米尼克</td>
          <td>Dominica</td>
          <td style="overflow: hidden">theCommonwealthofDominica</td>
          <td>DM</td>
          <td>DMA</td>
          <td style="text-align: center">212</td>
        </tr>
        <tr id="r62">
          <td style="text-align: center">62</td>
          <td>多米尼加</td>
          <td style="overflow: hidden">DominicanRepublic(the)</td>
          <td style="overflow: hidden">theDominicanRepublic</td>
          <td>DO</td>
          <td>DOM</td>
          <td style="text-align: center">214</td>
        </tr>
        <tr id="r63">
          <td style="text-align: center">63</td>
          <td>厄瓜多尔</td>
          <td>Ecuador</td>
          <td style="overflow: hidden">theRepublicofEcuador</td>
          <td>EC</td>
          <td>ECU</td>
          <td style="text-align: center">218</td>
        </tr>
        <tr id="r64">
          <td style="text-align: center">64</td>
          <td>埃及</td>
          <td>Egypt</td>
          <td style="overflow: hidden">theArabRepublicofEgypt</td>
          <td>EG</td>
          <td>EGY</td>
          <td style="text-align: center">818</td>
        </tr>
        <tr id="r65">
          <td style="text-align: center">65</td>
          <td>萨尔瓦多</td>
          <td>ElSalvador</td>
          <td style="overflow: hidden">theRepublicofElSalvador</td>
          <td>SV</td>
          <td>SLV</td>
          <td style="text-align: center">222</td>
        </tr>
        <tr id="r66">
          <td style="text-align: center">66</td>
          <td>赤道几内亚</td>
          <td style="overflow: hidden">EquatorialGuinea</td>
          <td style="overflow: hidden">theRepublicofEquatorialGuinea</td>
          <td>GQ</td>
          <td>GNQ</td>
          <td style="text-align: center">226</td>
        </tr>
        <tr id="r67">
          <td style="text-align: center; height: 11.25pt">67</td>
          <td>厄立特里亚</td>
          <td>Eritrea</td>
          <td>/</td>
          <td>ER</td>
          <td>ERI</td>
          <td style="text-align: center">232</td>
        </tr>
        <tr id="r68">
          <td style="text-align: center">68</td>
          <td>爱沙尼亚</td>
          <td>Estonia</td>
          <td style="overflow: hidden">theRepublicofEstonia</td>
          <td>EE</td>
          <td>EST</td>
          <td style="text-align: center">233</td>
        </tr>
        <tr style="height: 48.75pt" id="r69">
          <td style="text-align: center; height: 45.75pt">69</td>
          <td>埃塞俄比亚</td>
          <td>Ethiopia</td>
          <td style="overflow: hidden">
            theFederalDemocraticRepublicofEthiopia
          </td>
          <td>ET</td>
          <td>ETH</td>
          <td style="text-align: center">231</td>
        </tr>
        <tr id="r70">
          <td style="text-align: center">70</td>
          <td style="overflow: hidden">福克兰群岛（马尔维纳斯）</td>
          <td style="overflow: hidden">FalklandIslands(the)[Malvinas]</td>
          <td>/</td>
          <td>FK</td>
          <td>FLK</td>
          <td style="text-align: center">238</td>
        </tr>
        <tr id="r71">
          <td style="text-align: center">71</td>
          <td>法罗群岛</td>
          <td style="overflow: hidden">FaroeIslands(the)</td>
          <td>/</td>
          <td>FO</td>
          <td>FRO</td>
          <td style="text-align: center">234</td>
        </tr>
        <tr id="r72">
          <td style="text-align: center">72</td>
          <td>斐济</td>
          <td>Fiji</td>
          <td style="overflow: hidden">theRepublicoftheFijiIslands</td>
          <td>FJ</td>
          <td>FJI</td>
          <td style="text-align: center">242</td>
        </tr>
        <tr id="r73">
          <td style="text-align: center">73</td>
          <td>芬兰</td>
          <td>Finland</td>
          <td style="overflow: hidden">theRepublicofFinland</td>
          <td>FI</td>
          <td>FIN</td>
          <td style="text-align: center">246</td>
        </tr>
        <tr id="r74">
          <td style="text-align: center">74</td>
          <td>法国</td>
          <td>France</td>
          <td style="overflow: hidden">theFrenchRepublic</td>
          <td>FR</td>
          <td>FRA</td>
          <td style="text-align: center">250</td>
        </tr>
        <tr id="r75">
          <td style="text-align: center">75</td>
          <td>法属圭亚那</td>
          <td style="overflow: hidden">FrenchGuiana</td>
          <td>/</td>
          <td>GF</td>
          <td>GUF</td>
          <td style="text-align: center">254</td>
        </tr>
        <tr id="r76">
          <td style="text-align: center">76</td>
          <td>法属波利尼西亚</td>
          <td style="overflow: hidden">FrenchPolynesia</td>
          <td>/</td>
          <td>PF</td>
          <td>PYF</td>
          <td style="text-align: center">258</td>
        </tr>
        <tr id="r77">
          <td style="text-align: center">77</td>
          <td>法属南部领地</td>
          <td style="overflow: hidden">FrenchSouthernTerritories(the)</td>
          <td>/</td>
          <td>TF</td>
          <td>ATF</td>
          <td style="text-align: center">260</td>
        </tr>
        <tr id="r78">
          <td style="text-align: center">78</td>
          <td>加蓬</td>
          <td>Gabon</td>
          <td style="overflow: hidden">theGaboneseRepublic</td>
          <td>GA</td>
          <td>GAB</td>
          <td style="text-align: center">266</td>
        </tr>
        <tr id="r79">
          <td style="text-align: center">79</td>
          <td>冈比亚</td>
          <td style="overflow: hidden">Gambia(The)</td>
          <td style="overflow: hidden">theRepublicofTheGambia</td>
          <td>GM</td>
          <td>GMB</td>
          <td style="text-align: center">270</td>
        </tr>
        <tr id="r80">
          <td style="text-align: center; height: 11.25pt">80</td>
          <td>格鲁吉亚</td>
          <td>Georgia</td>
          <td>/</td>
          <td>GE</td>
          <td>GEO</td>
          <td style="text-align: center">268</td>
        </tr>
        <tr id="r81">
          <td style="text-align: center">81</td>
          <td>德国</td>
          <td>Germany</td>
          <td style="overflow: hidden">heFederalRepublicofGermany</td>
          <td>DE</td>
          <td>DEU</td>
          <td style="text-align: center">276</td>
        </tr>
        <tr id="r82">
          <td style="text-align: center">82</td>
          <td>加纳</td>
          <td>Ghana</td>
          <td style="overflow: hidden">theRepublicofGhana</td>
          <td>GH</td>
          <td>GHA</td>
          <td style="text-align: center">288</td>
        </tr>
        <tr id="r83">
          <td style="text-align: center; height: 11.25pt">83</td>
          <td>直布罗陀</td>
          <td>Gibraltar</td>
          <td>/</td>
          <td>GI</td>
          <td>GIB</td>
          <td style="text-align: center">292</td>
        </tr>
        <tr id="r84">
          <td style="text-align: center">84</td>
          <td>希腊</td>
          <td>Greece</td>
          <td style="overflow: hidden">theHellenicRepublic</td>
          <td>GR</td>
          <td>GRC</td>
          <td style="text-align: center">300</td>
        </tr>
        <tr id="r85">
          <td style="text-align: center; height: 11.25pt">85</td>
          <td>格陵兰</td>
          <td>Greenland</td>
          <td>/</td>
          <td>GL</td>
          <td>GRL</td>
          <td style="text-align: center">304</td>
        </tr>
        <tr id="r86">
          <td style="text-align: center; height: 11.25pt">86</td>
          <td>格林纳达</td>
          <td>Grenada</td>
          <td>/</td>
          <td>GD</td>
          <td>GRD</td>
          <td style="text-align: center">308</td>
        </tr>
        <tr id="r87">
          <td style="text-align: center">87</td>
          <td>瓜德罗普</td>
          <td>Guadeloupe</td>
          <td>/</td>
          <td>GP</td>
          <td>GLP</td>
          <td style="text-align: center">312</td>
        </tr>
        <tr id="r88">
          <td style="text-align: center; height: 11.25pt">88</td>
          <td>关岛</td>
          <td>Guam</td>
          <td>/</td>
          <td>GU</td>
          <td>GUM</td>
          <td style="text-align: center">316</td>
        </tr>
        <tr id="r89">
          <td style="text-align: center">89</td>
          <td>危地马拉</td>
          <td>Guatemala</td>
          <td style="overflow: hidden">theRepublicofGuatemala</td>
          <td>GT</td>
          <td>GTM</td>
          <td style="text-align: center">320</td>
        </tr>
        <tr id="r90">
          <td style="text-align: center; height: 11.25pt">90</td>
          <td>格恩西岛</td>
          <td>Guernsey</td>
          <td>/</td>
          <td>GG</td>
          <td>GGY</td>
          <td style="text-align: center">831</td>
        </tr>
        <tr id="r91">
          <td style="text-align: center">91</td>
          <td>几内亚</td>
          <td>Guinea</td>
          <td style="overflow: hidden">theRepublicofGuinea</td>
          <td>GN</td>
          <td>GIN</td>
          <td style="text-align: center">324</td>
        </tr>
        <tr id="r92">
          <td style="text-align: center">92</td>
          <td>几内亚比绍</td>
          <td style="overflow: hidden">Guinea-Bissau</td>
          <td style="overflow: hidden">theRepublicofGuinea-Bissau</td>
          <td>GW</td>
          <td>GNB</td>
          <td style="text-align: center">624</td>
        </tr>
        <tr id="r93">
          <td style="text-align: center">93</td>
          <td>圭亚那</td>
          <td>Guyana</td>
          <td style="overflow: hidden">theRepublicofGuyana</td>
          <td>GY</td>
          <td>GUY</td>
          <td style="text-align: center">328</td>
        </tr>
        <tr id="r94">
          <td style="text-align: center">94</td>
          <td>海地</td>
          <td>Haiti</td>
          <td style="overflow: hidden">theRepublicofHaiti</td>
          <td>HT</td>
          <td>HTI</td>
          <td style="text-align: center">332</td>
        </tr>
        <tr id="r95">
          <td style="text-align: center">95</td>
          <td style="overflow: hidden">赫德岛和麦克唐纳岛</td>
          <td style="overflow: hidden">HeardIslandandMcDonaldIslands</td>
          <td>/</td>
          <td>HM</td>
          <td>HMD</td>
          <td style="text-align: center">334</td>
        </tr>
        <tr id="r96">
          <td style="text-align: center">96</td>
          <td>梵蒂冈</td>
          <td style="overflow: hidden">HolySee(the)[VaticanCityState]</td>
          <td>/</td>
          <td>VA</td>
          <td>VAT</td>
          <td style="text-align: center">336</td>
        </tr>
        <tr id="r97">
          <td style="text-align: center">97</td>
          <td>洪都拉斯</td>
          <td>Honduras</td>
          <td style="overflow: hidden">theRepublicofHonduras</td>
          <td>HN</td>
          <td>HND</td>
          <td style="text-align: center">340</td>
        </tr>
        <tr height="81" style="height: 60.75pt" id="r98">
          <td height="77" style="text-align: center; height: 57.75pt">98</td>
          <td>香港</td>
          <td>HongKong</td>
          <td style="overflow: hidden">
            theHongKongSpecialAdministrativeRegionofChina
          </td>
          <td>HK</td>
          <td>HKG</td>
          <td style="text-align: center">344</td>
        </tr>
        <tr id="r99">
          <td style="text-align: center">99</td>
          <td>匈牙利</td>
          <td>Hungary</td>
          <td style="overflow: hidden">theRepublicofHungary</td>
          <td>HU</td>
          <td>HUN</td>
          <td style="text-align: center">348</td>
        </tr>
        <tr id="r100">
          <td style="text-align: center">100</td>
          <td>冰岛</td>
          <td>Iceland</td>
          <td style="overflow: hidden">theRepublicofIceland</td>
          <td>IS</td>
          <td>ISL</td>
          <td style="text-align: center">352</td>
        </tr>
        <tr id="r101">
          <td style="text-align: center">101</td>
          <td>印度</td>
          <td>India</td>
          <td style="overflow: hidden">theRepublicofIndia</td>
          <td>IN</td>
          <td>IND</td>
          <td style="text-align: center">356</td>
        </tr>
        <tr id="r102">
          <td style="text-align: center">102</td>
          <td>印度尼西亚</td>
          <td>Indonesia</td>
          <td style="overflow: hidden">theRepublicofIndonesia</td>
          <td>ID</td>
          <td>IDN</td>
          <td style="text-align: center">360</td>
        </tr>
        <tr id="r103">
          <td style="text-align: center">103</td>
          <td>伊朗</td>
          <td style="overflow: hidden">Iran(theIslamicRepublicof)</td>
          <td style="overflow: hidden">theIslamicRepublicofIran</td>
          <td>IR</td>
          <td>IRN</td>
          <td style="text-align: center">364</td>
        </tr>
        <tr id="r104">
          <td style="text-align: center">104</td>
          <td>伊拉克</td>
          <td>Iraq</td>
          <td style="overflow: hidden">theRepublicofIraq</td>
          <td>IQ</td>
          <td>IRQ</td>
          <td style="text-align: center">368</td>
        </tr>
        <tr id="r105">
          <td style="text-align: center; height: 11.25pt">105</td>
          <td>爱尔兰</td>
          <td>Ireland</td>
          <td>/</td>
          <td>IE</td>
          <td>IRL</td>
          <td style="text-align: center">372</td>
        </tr>
        <tr id="r106">
          <td style="text-align: center">106</td>
          <td>英国属地曼岛</td>
          <td>IsleofMan</td>
          <td>/</td>
          <td>IM</td>
          <td>IMN</td>
          <td style="text-align: center">833</td>
        </tr>
        <tr id="r107">
          <td style="text-align: center">107</td>
          <td>以色列</td>
          <td>Israel</td>
          <td style="overflow: hidden">theStateofIsrael</td>
          <td>IL</td>
          <td>ISR</td>
          <td style="text-align: center">376</td>
        </tr>
        <tr id="r108">
          <td style="text-align: center">108</td>
          <td>意大利</td>
          <td>Italy</td>
          <td style="overflow: hidden">theRepublicofItaly</td>
          <td>IT</td>
          <td>ITA</td>
          <td style="text-align: center">380</td>
        </tr>
        <tr id="r109">
          <td style="text-align: center; height: 11.25pt">109</td>
          <td>牙买加</td>
          <td>Jamaica</td>
          <td>/</td>
          <td>JM</td>
          <td>JAM</td>
          <td style="text-align: center">388</td>
        </tr>
        <tr id="r110">
          <td style="text-align: center; height: 11.25pt">110</td>
          <td>日本</td>
          <td>Japan</td>
          <td>/</td>
          <td>JP</td>
          <td>JPN</td>
          <td style="text-align: center">392</td>
        </tr>
        <tr id="r111">
          <td style="text-align: center; height: 11.25pt">111</td>
          <td>泽西岛</td>
          <td>Jersey</td>
          <td>/</td>
          <td>JE</td>
          <td>JEY</td>
          <td style="text-align: center">832</td>
        </tr>
        <tr id="r112">
          <td style="text-align: center">112</td>
          <td>约旦</td>
          <td>Jordan</td>
          <td style="overflow: hidden">theHashemiteKingdomofJordan</td>
          <td>JO</td>
          <td>JOR</td>
          <td style="text-align: center">400</td>
        </tr>
        <tr id="r113">
          <td style="text-align: center">113</td>
          <td>哈萨克斯坦</td>
          <td>Kazakhstan</td>
          <td style="overflow: hidden">theRepublicofKazakhstan</td>
          <td>KZ</td>
          <td>KAZ</td>
          <td style="text-align: center">398</td>
        </tr>
        <tr id="r114">
          <td style="text-align: center">114</td>
          <td>肯尼亚</td>
          <td>Kenya</td>
          <td style="overflow: hidden">theRepublicofKenya</td>
          <td>KE</td>
          <td>KEN</td>
          <td style="text-align: center">404</td>
        </tr>
        <tr id="r115">
          <td style="text-align: center">115</td>
          <td>基里巴斯</td>
          <td>Kiribati</td>
          <td style="overflow: hidden">theRepublicofKiribati</td>
          <td>KI</td>
          <td>KIR</td>
          <td style="text-align: center">296</td>
        </tr>
        <tr style="height: 48.75pt" id="r116">
          <td style="text-align: center; height: 45.75pt">116</td>
          <td>朝鲜</td>
          <td style="overflow: hidden">
            Korea(theDemocraticPeople'sRepublicof)
          </td>
          <td style="overflow: hidden">theDemocraticPeople'sRepublicofKorea</td>
          <td>KP</td>
          <td>PRK</td>
          <td style="text-align: center">408</td>
        </tr>
        <tr id="r117">
          <td style="text-align: center">117</td>
          <td>韩国</td>
          <td style="overflow: hidden">Korea(theRepublicof)</td>
          <td style="overflow: hidden">theRepublicofKorea</td>
          <td>KR</td>
          <td>KOR</td>
          <td style="text-align: center">410</td>
        </tr>
        <tr id="r118">
          <td style="text-align: center">118</td>
          <td>科威特</td>
          <td>Kuwait</td>
          <td style="overflow: hidden">heStateofKuwait</td>
          <td>KW</td>
          <td>KWT</td>
          <td style="text-align: center">414</td>
        </tr>
        <tr id="r119">
          <td style="text-align: center">119</td>
          <td>吉尔吉斯斯坦</td>
          <td>Kyrgyzstan</td>
          <td style="overflow: hidden">theKyrgyzRepublic</td>
          <td>KG</td>
          <td>KGZ</td>
          <td style="text-align: center">417</td>
        </tr>
        <tr style="height: 48.75pt" id="r120">
          <td style="text-align: center; height: 45.75pt">120</td>
          <td>老挝</td>
          <td style="overflow: hidden">LaoPeople'sDemocraticRepublic(the)</td>
          <td style="overflow: hidden">theLaoPeople'sDemocraticRepublic</td>
          <td>LA</td>
          <td>LAO</td>
          <td style="text-align: center">418</td>
        </tr>
        <tr id="r121">
          <td style="text-align: center">121</td>
          <td>拉脱维亚</td>
          <td>Latvia</td>
          <td style="overflow: hidden">theRepublicofLatvia</td>
          <td>LV</td>
          <td>LVA</td>
          <td style="text-align: center">428</td>
        </tr>
        <tr id="r122">
          <td style="text-align: center">122</td>
          <td>黎巴嫩</td>
          <td>Lebanon</td>
          <td style="overflow: hidden">theLebaneseRepublic</td>
          <td>LB</td>
          <td>LBN</td>
          <td style="text-align: center">422</td>
        </tr>
        <tr id="r123">
          <td style="text-align: center">123</td>
          <td>莱索托</td>
          <td>Lesotho</td>
          <td style="overflow: hidden">theKingdomofLesotho</td>
          <td>LS</td>
          <td>LSO</td>
          <td style="text-align: center">426</td>
        </tr>
        <tr id="r124">
          <td style="text-align: center">124</td>
          <td>利比里亚</td>
          <td>Liberia</td>
          <td style="overflow: hidden">theRepublicofLiberia</td>
          <td>LR</td>
          <td>LBR</td>
          <td style="text-align: center">430</td>
        </tr>
        <tr style="height: 48.75pt" id="r125">
          <td style="text-align: center; height: 45.75pt">125</td>
          <td>利比亚</td>
          <td style="overflow: hidden">LibyanArabJamahiriya(the)</td>
          <td style="overflow: hidden">
            theSocialistPeople'sLibyanArabJamahiriya
          </td>
          <td>LY</td>
          <td>LBY</td>
          <td style="text-align: center">434</td>
        </tr>
        <tr id="r126">
          <td style="text-align: center">126</td>
          <td>列支敦士登</td>
          <td style="overflow: hidden">Liechtenstein</td>
          <td style="overflow: hidden">thePrincipalityofLiechtenstein</td>
          <td>LI</td>
          <td>LIE</td>
          <td style="text-align: center">438</td>
        </tr>
        <tr id="r127">
          <td style="text-align: center">127</td>
          <td>立陶宛</td>
          <td>Lithuania</td>
          <td style="overflow: hidden">theRepublicofLithuania</td>
          <td>LT</td>
          <td>LTU</td>
          <td style="text-align: center">440</td>
        </tr>
        <tr id="r128">
          <td style="text-align: center">128</td>
          <td>卢森堡</td>
          <td>Luxembourg</td>
          <td style="overflow: hidden">theGrandDuchyofLuxembourg</td>
          <td>LU</td>
          <td>LUX</td>
          <td style="text-align: center">442</td>
        </tr>
        <tr style="height: 48.75pt" id="r129">
          <td style="text-align: center; height: 45.75pt">129</td>
          <td>澳门</td>
          <td>Macao</td>
          <td style="overflow: hidden">
            MacaoSpecialAdministrativeRegionofChina
          </td>
          <td>MO</td>
          <td>MAC</td>
          <td style="text-align: center">446</td>
        </tr>
        <tr style="height: 48.75pt" id="r130">
          <td style="text-align: center; height: 45.75pt">130</td>
          <td>前南马其顿</td>
          <td style="overflow: hidden">
            Macedonia(theformerYugoslavRepublicof)
          </td>
          <td style="overflow: hidden">theformerYugoslavRepublicofMacedonia</td>
          <td>MK</td>
          <td>MKD</td>
          <td style="text-align: center">807</td>
        </tr>
        <tr id="r131">
          <td style="text-align: center">131</td>
          <td>马达加斯加</td>
          <td>Madagascar</td>
          <td style="overflow: hidden">theRepublicofMadagascar</td>
          <td>MG</td>
          <td>MDG</td>
          <td style="text-align: center">450</td>
        </tr>
        <tr id="r132">
          <td style="text-align: center">132</td>
          <td>马拉维</td>
          <td>Malawi</td>
          <td style="overflow: hidden">theRepublicofMalawi</td>
          <td>MW</td>
          <td>MWI</td>
          <td style="text-align: center">454</td>
        </tr>
        <tr id="r133">
          <td style="text-align: center; height: 11.25pt">133</td>
          <td>马来西亚</td>
          <td>Malaysia</td>
          <td>/</td>
          <td>MY</td>
          <td>MYS</td>
          <td style="text-align: center">458</td>
        </tr>
        <tr id="r134">
          <td style="text-align: center">134</td>
          <td>马尔代夫</td>
          <td>Maldives</td>
          <td style="overflow: hidden">theRepublicofMaldives</td>
          <td>MV</td>
          <td>MDV</td>
          <td style="text-align: center">462</td>
        </tr>
        <tr id="r135">
          <td style="text-align: center">135</td>
          <td>马里</td>
          <td>Mali</td>
          <td style="overflow: hidden">theRepublicofMali</td>
          <td>ML</td>
          <td>MLI</td>
          <td style="text-align: center">466</td>
        </tr>
        <tr id="r136">
          <td style="text-align: center">136</td>
          <td>马耳他</td>
          <td>Malta</td>
          <td style="overflow: hidden">theRepublicofMalta</td>
          <td>MT</td>
          <td>MLT</td>
          <td style="text-align: center">470</td>
        </tr>
        <tr id="r137">
          <td style="text-align: center">137</td>
          <td>马绍尔群岛</td>
          <td style="overflow: hidden">MarshallIslands(the)</td>
          <td style="overflow: hidden">theRepublicoftheMarshallIslands</td>
          <td>MH</td>
          <td>MHL</td>
          <td style="text-align: center">584</td>
        </tr>
        <tr id="r138">
          <td style="text-align: center; height: 11.25pt">138</td>
          <td>马提尼克</td>
          <td>Martinique</td>
          <td>/</td>
          <td>MQ</td>
          <td>MTQ</td>
          <td style="text-align: center">474</td>
        </tr>
        <tr id="r139">
          <td style="text-align: center">139</td>
          <td>毛里塔尼亚</td>
          <td>Mauritania</td>
          <td style="overflow: hidden">theIslamicRepublicofMauritania</td>
          <td>MR</td>
          <td>MRT</td>
          <td style="text-align: center">478</td>
        </tr>
        <tr id="r140">
          <td style="text-align: center">140</td>
          <td>毛里求斯</td>
          <td>Mauritius</td>
          <td style="overflow: hidden">theRepublicofMauritius</td>
          <td>MU</td>
          <td>MUS</td>
          <td style="text-align: center">480</td>
        </tr>
        <tr id="r141">
          <td style="text-align: center; height: 11.25pt">141</td>
          <td>马约特</td>
          <td>Mayotte</td>
          <td>/</td>
          <td>YT</td>
          <td>MYT</td>
          <td style="text-align: center">175</td>
        </tr>
        <tr id="r142">
          <td style="text-align: center">142</td>
          <td>墨西哥</td>
          <td>Mexico</td>
          <td style="overflow: hidden">theUnitedMexicanStates</td>
          <td>MX</td>
          <td>MEX</td>
          <td style="text-align: center">484</td>
        </tr>
        <tr id="r143">
          <td style="text-align: center">143</td>
          <td>密克罗尼西亚联邦</td>
          <td style="overflow: hidden">Micronesia(theFederatedStatesof)</td>
          <td style="overflow: hidden">theFederatedStatesofMicronesia</td>
          <td>FM</td>
          <td>FSM</td>
          <td style="text-align: center">583</td>
        </tr>
        <tr id="r144">
          <td style="text-align: center">144</td>
          <td>摩尔多瓦</td>
          <td style="overflow: hidden">Moldova(theRepublicof)</td>
          <td style="overflow: hidden">theRepublicofMoldova</td>
          <td>MD</td>
          <td>MDA</td>
          <td style="text-align: center">498</td>
        </tr>
        <tr id="r145">
          <td style="text-align: center">145</td>
          <td>摩纳哥</td>
          <td>Monaco</td>
          <td style="overflow: hidden">thePrincipalityofMonaco</td>
          <td>MC</td>
          <td>MCO</td>
          <td style="text-align: center">492</td>
        </tr>
        <tr id="r146">
          <td style="text-align: center; height: 11.25pt">146</td>
          <td>蒙古</td>
          <td>Mongolia</td>
          <td>/</td>
          <td>MN</td>
          <td>MNG</td>
          <td style="text-align: center">496</td>
        </tr>
        <tr id="r147">
          <td style="text-align: center">147</td>
          <td>黑山</td>
          <td>Montenegro</td>
          <td style="overflow: hidden">theRepublicofMontenegro</td>
          <td>ME</td>
          <td>MNE</td>
          <td style="text-align: center">499</td>
        </tr>
        <tr id="r148">
          <td style="text-align: center; height: 11.25pt">148</td>
          <td>蒙特塞拉特</td>
          <td>Montserrat</td>
          <td>/</td>
          <td>MS</td>
          <td>MSR</td>
          <td style="text-align: center">500</td>
        </tr>
        <tr id="r149">
          <td style="text-align: center">149</td>
          <td>摩洛哥</td>
          <td>Morocco</td>
          <td style="overflow: hidden">theKingdomofMorocco</td>
          <td>MA</td>
          <td>MAR</td>
          <td style="text-align: center">504</td>
        </tr>
        <tr id="r150">
          <td style="text-align: center">150</td>
          <td>莫桑比克</td>
          <td>Mozambique</td>
          <td style="overflow: hidden">theRepublicofMozambique</td>
          <td>MZ</td>
          <td>MOZ</td>
          <td style="text-align: center">508</td>
        </tr>
        <tr id="r151">
          <td style="text-align: center">151</td>
          <td>缅甸</td>
          <td>Myanmar</td>
          <td style="overflow: hidden">theUnionofMyanmar</td>
          <td>MM</td>
          <td>MMR</td>
          <td style="text-align: center">104</td>
        </tr>
        <tr id="r152">
          <td style="text-align: center">152</td>
          <td>纳米比亚</td>
          <td>Namibia</td>
          <td style="overflow: hidden">theRepublicofNamibia</td>
          <td>NA</td>
          <td>NAM</td>
          <td style="text-align: center">516</td>
        </tr>
        <tr id="r153">
          <td style="text-align: center">153</td>
          <td>瑙鲁</td>
          <td>Nauru</td>
          <td style="overflow: hidden">theRepublicofNauru</td>
          <td>NR</td>
          <td>NRU</td>
          <td style="text-align: center">520</td>
        </tr>
        <tr id="r154">
          <td style="text-align: center; height: 11.25pt">154</td>
          <td>尼泊尔</td>
          <td>Nepal</td>
          <td>Nepal</td>
          <td>NP</td>
          <td>NPL</td>
          <td style="text-align: center">524</td>
        </tr>
        <tr id="r155">
          <td style="text-align: center">155</td>
          <td>荷兰</td>
          <td style="overflow: hidden">Netherlands(the)</td>
          <td style="overflow: hidden">theKingdomoftheNetherlands</td>
          <td>NL</td>
          <td>NLD</td>
          <td style="text-align: center">528</td>
        </tr>
        <tr id="r156">
          <td style="text-align: center">156</td>
          <td>荷属安的列斯</td>
          <td style="overflow: hidden">NetherlandsAntilles(the)</td>
          <td>/</td>
          <td>AN</td>
          <td>ANT</td>
          <td style="text-align: center">530</td>
        </tr>
        <tr id="r157">
          <td style="text-align: center">157</td>
          <td>新喀里多尼亚</td>
          <td style="overflow: hidden">NewCaledonia</td>
          <td>/</td>
          <td>NC</td>
          <td>NCL</td>
          <td style="text-align: center">540</td>
        </tr>
        <tr id="r158">
          <td style="text-align: center">158</td>
          <td>新西兰</td>
          <td>NewZealand</td>
          <td>/</td>
          <td>NZ</td>
          <td>NZL</td>
          <td style="text-align: center">554</td>
        </tr>
        <tr id="r159">
          <td style="text-align: center">159</td>
          <td>尼加拉瓜</td>
          <td>Nicaragua</td>
          <td style="overflow: hidden">theRepublicofNicaragua/</td>
          <td>NI</td>
          <td>NIC</td>
          <td style="text-align: center">558</td>
        </tr>
        <tr id="r160">
          <td style="text-align: center">160</td>
          <td>尼日尔</td>
          <td>Niger(the)</td>
          <td style="overflow: hidden">theRepublicoftheNiger</td>
          <td>NE</td>
          <td>NER</td>
          <td style="text-align: center">562</td>
        </tr>
        <tr id="r161">
          <td style="text-align: center">161</td>
          <td>尼日利亚</td>
          <td>Nigeria</td>
          <td style="overflow: hidden">theFederalRepublicofNigeria</td>
          <td>NG</td>
          <td>NGA</td>
          <td style="text-align: center">566</td>
        </tr>
        <tr id="r162">
          <td style="text-align: center">162</td>
          <td>纽埃</td>
          <td>Niue</td>
          <td style="overflow: hidden">theRepublicofNiue</td>
          <td>NU</td>
          <td>NIU</td>
          <td style="text-align: center">570</td>
        </tr>
        <tr id="r163">
          <td style="text-align: center">163</td>
          <td>诺福克岛</td>
          <td style="overflow: hidden">NorfolkIsland</td>
          <td>/</td>
          <td>NF</td>
          <td>NFK</td>
          <td style="text-align: center">574</td>
        </tr>
        <tr height="81" style="height: 60.75pt" id="r164">
          <td height="77" style="text-align: center; height: 57.75pt">164</td>
          <td>北马里亚纳</td>
          <td style="overflow: hidden">NorthernMarianaIslands(the)</td>
          <td style="overflow: hidden">
            theCommonwealthoftheNorthernMarianaIslands
          </td>
          <td>MP</td>
          <td>MNP</td>
          <td style="text-align: center">580</td>
        </tr>
        <tr id="r165">
          <td style="text-align: center">165</td>
          <td>挪威</td>
          <td>Norway</td>
          <td style="overflow: hidden">theKingdomofNorway</td>
          <td>NO</td>
          <td>NOR</td>
          <td style="text-align: center">578</td>
        </tr>
        <tr id="r166">
          <td style="text-align: center">166</td>
          <td>阿曼</td>
          <td>Oman</td>
          <td style="overflow: hidden">theSultanateofOman</td>
          <td>OM</td>
          <td>OMN</td>
          <td style="text-align: center">512</td>
        </tr>
        <tr id="r167">
          <td style="text-align: center">167</td>
          <td>巴基斯坦</td>
          <td>Pakistan</td>
          <td style="overflow: hidden">theIslamicRepublicofPakistan</td>
          <td>PK</td>
          <td>PAK</td>
          <td style="text-align: center">586</td>
        </tr>
        <tr id="r168">
          <td style="text-align: center">168</td>
          <td>帕劳</td>
          <td>Palau</td>
          <td style="overflow: hidden">theRepublicofPalau</td>
          <td>PW</td>
          <td>PLW</td>
          <td style="text-align: center">585</td>
        </tr>
        <tr id="r169">
          <td style="text-align: center">169</td>
          <td>巴勒斯坦</td>
          <td style="overflow: hidden">PalestinianTerritory(theOccupied)</td>
          <td style="overflow: hidden">theOccupiedPalestinianTerritory</td>
          <td>PS</td>
          <td>PSE</td>
          <td style="text-align: center">275</td>
        </tr>
        <tr id="r170">
          <td style="text-align: center">170</td>
          <td>巴拿马</td>
          <td>Panama</td>
          <td style="overflow: hidden">theRepublicofPanama</td>
          <td>PA</td>
          <td>PAN</td>
          <td style="text-align: center">591</td>
        </tr>
        <tr id="r171">
          <td style="text-align: center">171</td>
          <td>巴布亚新几内亚</td>
          <td style="overflow: hidden">PapuaNewGuinea</td>
          <td>/</td>
          <td>PG</td>
          <td>PNG</td>
          <td style="text-align: center">598</td>
        </tr>
        <tr id="r172">
          <td style="text-align: center">172</td>
          <td>巴拉圭</td>
          <td>Paraguay</td>
          <td style="overflow: hidden">theRepublicofParaguay</td>
          <td>PY</td>
          <td>PRY</td>
          <td style="text-align: center">600</td>
        </tr>
        <tr id="r173">
          <td style="text-align: center">173</td>
          <td>秘鲁</td>
          <td>Peru</td>
          <td style="overflow: hidden">theRepublicofPeru</td>
          <td>PE</td>
          <td>PER</td>
          <td style="text-align: center">604</td>
        </tr>
        <tr id="r174">
          <td style="text-align: center">174</td>
          <td>菲律宾</td>
          <td style="overflow: hidden">Philippines(the)</td>
          <td style="overflow: hidden">theRepublicofthePhilippines</td>
          <td>PH</td>
          <td>PHL</td>
          <td style="text-align: center">608</td>
        </tr>
        <tr id="r175">
          <td style="text-align: center; height: 11.25pt">175</td>
          <td>皮特凯恩</td>
          <td>Pitcairn</td>
          <td>/</td>
          <td>PN</td>
          <td>PCN</td>
          <td style="text-align: center">612</td>
        </tr>
        <tr id="r176">
          <td style="text-align: center">176</td>
          <td>波兰</td>
          <td>Poland</td>
          <td style="overflow: hidden">theRepublicofPoland</td>
          <td>PL</td>
          <td>POL</td>
          <td style="text-align: center">616</td>
        </tr>
        <tr id="r177">
          <td style="text-align: center">177</td>
          <td>葡萄牙</td>
          <td>Portugal</td>
          <td style="overflow: hidden">thePortugueseRepublic</td>
          <td>PT</td>
          <td>PRT</td>
          <td style="text-align: center">620</td>
        </tr>
        <tr id="r178">
          <td style="text-align: center; height: 11.25pt">178</td>
          <td>波多黎各</td>
          <td>PuertoRico</td>
          <td>/</td>
          <td>PR</td>
          <td>PRI</td>
          <td style="text-align: center">630</td>
        </tr>
        <tr id="r179">
          <td style="text-align: center">179</td>
          <td>卡塔尔</td>
          <td>Qatar</td>
          <td style="overflow: hidden">theStateofQatar</td>
          <td>QA</td>
          <td>QAT</td>
          <td style="text-align: center">634</td>
        </tr>
        <tr id="r180">
          <td style="text-align: center; height: 11.25pt">180</td>
          <td>留尼汪</td>
          <td>Réunion</td>
          <td>/</td>
          <td>RE</td>
          <td>REU</td>
          <td style="text-align: center">638</td>
        </tr>
        <tr id="r181">
          <td style="text-align: center; height: 11.25pt">181</td>
          <td>罗马尼亚</td>
          <td>Romania</td>
          <td>/</td>
          <td>RO</td>
          <td>ROM</td>
          <td style="text-align: center">642</td>
        </tr>
        <tr id="r182">
          <td style="text-align: center">182</td>
          <td>俄罗斯联邦</td>
          <td style="overflow: hidden">RussianFederation(the)</td>
          <td style="overflow: hidden">theRussianFederation</td>
          <td>RU</td>
          <td>RUS</td>
          <td style="text-align: center">643</td>
        </tr>
        <tr id="r183">
          <td style="text-align: center">183</td>
          <td>卢旺达</td>
          <td>Rwanda</td>
          <td style="overflow: hidden">theRepublicofRwanda</td>
          <td>RW</td>
          <td>RWA</td>
          <td style="text-align: center">646</td>
        </tr>
        <tr id="r184">
          <td style="text-align: center">184</td>
          <td>圣赫勒拿</td>
          <td>SaintHelena</td>
          <td>/</td>
          <td>SH</td>
          <td>SHN</td>
          <td style="text-align: center">654</td>
        </tr>
        <tr id="r185">
          <td style="text-align: center">185</td>
          <td>圣基茨和尼维斯</td>
          <td style="overflow: hidden">SaintKittsandNevis</td>
          <td>/</td>
          <td>KN</td>
          <td>KNA</td>
          <td style="text-align: center">659</td>
        </tr>
        <tr id="r186">
          <td style="text-align: center; height: 11.25pt">186</td>
          <td>圣卢西亚</td>
          <td>SaintLucia</td>
          <td>/</td>
          <td>LC</td>
          <td>LCA</td>
          <td style="text-align: center">662</td>
        </tr>
        <tr id="r187">
          <td style="text-align: center">187</td>
          <td>圣皮埃尔和密克隆</td>
          <td style="overflow: hidden">SaintPierreandMiquelon</td>
          <td>/</td>
          <td>PM</td>
          <td>SPM</td>
          <td style="text-align: center">666</td>
        </tr>
        <tr id="r188">
          <td style="text-align: center">188</td>
          <td style="overflow: hidden">圣文森特和格林纳丁斯</td>
          <td style="overflow: hidden">SaintVincentandtheGrenadines</td>
          <td>/</td>
          <td>VC</td>
          <td>VCT</td>
          <td style="text-align: center">670</td>
        </tr>
        <tr id="r189">
          <td style="text-align: center">189</td>
          <td>萨摩亚</td>
          <td>Samoa</td>
          <td style="overflow: hidden">theIndependentStateofSamoa</td>
          <td>WS</td>
          <td>WSM</td>
          <td style="text-align: center">882</td>
        </tr>
        <tr id="r190">
          <td style="text-align: center">190</td>
          <td>圣马力诺</td>
          <td>SanMarino</td>
          <td style="overflow: hidden">theRepublicofSanMarino</td>
          <td>SM</td>
          <td>SMR</td>
          <td style="text-align: center">674</td>
        </tr>
        <tr height="81" style="height: 60.75pt" id="r191">
          <td height="77" style="text-align: center; height: 57.75pt">191</td>
          <td>圣多美和普林西比</td>
          <td style="overflow: hidden">SaoTomeandPrincipe</td>
          <td style="overflow: hidden">
            theDemocraticRepublicofSaoTomeandPrincipe
          </td>
          <td>ST</td>
          <td>STP</td>
          <td style="text-align: center">678</td>
        </tr>
        <tr id="r192">
          <td style="text-align: center">192</td>
          <td>沙特阿拉伯</td>
          <td>SaudiArabia</td>
          <td style="overflow: hidden">theKingdomofSaudiArabia</td>
          <td>SA</td>
          <td>SAU</td>
          <td style="text-align: center">682</td>
        </tr>
        <tr id="r193">
          <td style="text-align: center">193</td>
          <td>塞内加尔</td>
          <td>Senegal</td>
          <td style="overflow: hidden">theRepublicofSenegal</td>
          <td>SN</td>
          <td>SEN</td>
          <td style="text-align: center">686</td>
        </tr>
        <tr id="r194">
          <td style="text-align: center">194</td>
          <td>塞尔维亚</td>
          <td>Serbia</td>
          <td style="overflow: hidden">theRepublicofSerbia</td>
          <td>RS</td>
          <td>SRB</td>
          <td style="text-align: center">688</td>
        </tr>
        <tr id="r195">
          <td style="text-align: center">195</td>
          <td>塞舌尔</td>
          <td>Seychelles</td>
          <td style="overflow: hidden">theRepublicofSeychelles</td>
          <td>SC</td>
          <td>SYC</td>
          <td style="text-align: center">690</td>
        </tr>
        <tr id="r196">
          <td style="text-align: center">196</td>
          <td>塞拉利昂</td>
          <td>SierraLeone</td>
          <td style="overflow: hidden">theRepublicofSierraLeone</td>
          <td>SL</td>
          <td>SLE</td>
          <td style="text-align: center">694</td>
        </tr>
        <tr id="r197">
          <td style="text-align: center">197</td>
          <td>新加坡</td>
          <td>Singapore</td>
          <td style="overflow: hidden">theRepublicofSingapore</td>
          <td>SG</td>
          <td>SGP</td>
          <td style="text-align: center">702</td>
        </tr>
        <tr id="r198">
          <td style="text-align: center">198</td>
          <td>斯洛伐克</td>
          <td>Slovakia</td>
          <td style="overflow: hidden">theSlovakRepublic</td>
          <td>SK</td>
          <td>SVK</td>
          <td style="text-align: center">703</td>
        </tr>
        <tr id="r199">
          <td style="text-align: center">199</td>
          <td>斯洛文尼亚</td>
          <td>Slovenia</td>
          <td style="overflow: hidden">theRepublicofSlovenia</td>
          <td>SI</td>
          <td>SVN</td>
          <td style="text-align: center">705</td>
        </tr>
        <tr id="r200">
          <td style="text-align: center">200</td>
          <td>所罗门群岛</td>
          <td style="overflow: hidden">SolomonIslands(the)</td>
          <td>/</td>
          <td>SB</td>
          <td>SLB</td>
          <td style="text-align: center">90</td>
        </tr>
        <tr id="r201">
          <td style="text-align: center">201</td>
          <td>索马里</td>
          <td>Somalia</td>
          <td style="overflow: hidden">theSomaliRepublic</td>
          <td>SO</td>
          <td>SOM</td>
          <td style="text-align: center">706</td>
        </tr>
        <tr id="r202">
          <td style="text-align: center">202</td>
          <td>南非</td>
          <td>SouthAfrica</td>
          <td style="overflow: hidden">theRepublicofSouthAfrica</td>
          <td>ZA</td>
          <td>ZAF</td>
          <td style="text-align: center">710</td>
        </tr>
        <tr style="height: 48.75pt" id="r203">
          <td style="text-align: center; height: 45.75pt">203</td>
          <td style="overflow: hidden">南乔治亚岛和南桑德韦奇岛</td>
          <td style="overflow: hidden">
            SouthGeorgiaandtheSouthSandwichIslands
          </td>
          <td>/</td>
          <td>GS</td>
          <td>SGS</td>
          <td style="text-align: center">239</td>
        </tr>
        <tr id="r204">
          <td style="text-align: center">204</td>
          <td>西班牙</td>
          <td>Spain</td>
          <td style="overflow: hidden">theKingdomofSpain</td>
          <td>ES</td>
          <td>ESP</td>
          <td style="text-align: center">724</td>
        </tr>
        <tr style="height: 48.75pt" id="r205">
          <td style="text-align: center; height: 45.75pt">205</td>
          <td>斯里兰卡</td>
          <td>SriLanka</td>
          <td style="overflow: hidden">
            theDemocraticSocialistRepublicofSriLanka
          </td>
          <td>LK</td>
          <td>LKA</td>
          <td style="text-align: center">144</td>
        </tr>
        <tr id="r206">
          <td style="text-align: center">206</td>
          <td>苏丹</td>
          <td>Sudan(the)</td>
          <td style="overflow: hidden">theRepublicoftheSudan</td>
          <td>SD</td>
          <td>SDN</td>
          <td style="text-align: center">736</td>
        </tr>
        <tr id="r207">
          <td style="text-align: center">207</td>
          <td>苏里南</td>
          <td>Suriname</td>
          <td style="overflow: hidden">theRepublicofSuriname</td>
          <td>SR</td>
          <td>SUR</td>
          <td style="text-align: center">740</td>
        </tr>
        <tr id="r208">
          <td style="text-align: center">208</td>
          <td style="overflow: hidden">斯瓦尔巴岛和扬马延岛</td>
          <td style="overflow: hidden">SvalbardandJanMayen</td>
          <td>/</td>
          <td>SJ</td>
          <td>SJM</td>
          <td style="text-align: center">744</td>
        </tr>
        <tr id="r209">
          <td style="text-align: center">209</td>
          <td>斯威士兰</td>
          <td>Swaziland</td>
          <td style="overflow: hidden">theKingdomofSwaziland</td>
          <td>SZ</td>
          <td>SWZ</td>
          <td style="text-align: center">748</td>
        </tr>
        <tr id="r210">
          <td style="text-align: center">210</td>
          <td>瑞典</td>
          <td>Sweden</td>
          <td style="overflow: hidden">theKingdomofSweden</td>
          <td>SE</td>
          <td>SWE</td>
          <td style="text-align: center">752</td>
        </tr>
        <tr id="r211">
          <td style="text-align: center">211</td>
          <td>瑞士</td>
          <td>Switzerland</td>
          <td style="overflow: hidden">theSwissConfederation</td>
          <td>CH</td>
          <td>CHE</td>
          <td style="text-align: center">756</td>
        </tr>
        <tr id="r212">
          <td style="text-align: center">212</td>
          <td>叙利亚</td>
          <td style="overflow: hidden">SyrianArabRepublic(the)</td>
          <td style="overflow: hidden">theSyrianArabRepublic</td>
          <td>SY</td>
          <td>SYR</td>
          <td style="text-align: center">760</td>
        </tr>
        <tr id="r213">
          <td
            colspan="7"
            class="x25"
            style="border-bottom: 2px solid #e6e6e6; height: 11.25pt"
          >
            T
          </td>
        </tr>
        <tr id="r214">
          <td style="text-align: center">213</td>
          <td>台湾</td>
          <td style="overflow: hidden">Taiwan(ProvinceofChina)</td>
          <td>/</td>
          <td>TW</td>
          <td>TWN</td>
          <td style="text-align: center">158</td>
        </tr>
        <tr id="r215">
          <td style="text-align: center">214</td>
          <td>塔吉克斯坦</td>
          <td>Tajikistan</td>
          <td style="overflow: hidden">theRepublicofTajikistan</td>
          <td>TJ</td>
          <td>TJK</td>
          <td style="text-align: center">762</td>
        </tr>
        <tr id="r216">
          <td style="text-align: center">215</td>
          <td>坦桑尼亚</td>
          <td style="overflow: hidden">Tanzania,UnitedRepublicof</td>
          <td style="overflow: hidden">theUnitedRepublicofTanzania</td>
          <td>TZ</td>
          <td>TZA</td>
          <td style="text-align: center">834</td>
        </tr>
        <tr id="r217">
          <td style="text-align: center">216</td>
          <td>泰国</td>
          <td>Thailand</td>
          <td style="overflow: hidden">theKingdomofThailand</td>
          <td>TH</td>
          <td>THA</td>
          <td style="text-align: center">764</td>
        </tr>
        <tr style="height: 48.75pt" id="r218">
          <td style="text-align: center; height: 45.75pt">217</td>
          <td>东帝汶</td>
          <td>Timor-Leste</td>
          <td style="overflow: hidden">theDemocraticRepublicofTimor-Leste</td>
          <td>TL</td>
          <td>TLS</td>
          <td style="text-align: center">626</td>
        </tr>
        <tr id="r219">
          <td style="text-align: center">218</td>
          <td>多哥</td>
          <td>Togo</td>
          <td style="overflow: hidden">theTogoleseRepublic</td>
          <td>TG</td>
          <td>TGO</td>
          <td style="text-align: center">768</td>
        </tr>
        <tr id="r220">
          <td style="text-align: center; height: 11.25pt">219</td>
          <td>托克劳</td>
          <td>Tokelau</td>
          <td>/</td>
          <td>TK</td>
          <td>TKL</td>
          <td style="text-align: center">772</td>
        </tr>
        <tr id="r221">
          <td style="text-align: center">220</td>
          <td>汤加</td>
          <td>Tonga</td>
          <td style="overflow: hidden">theKingdomofTonga</td>
          <td>TO</td>
          <td>TON</td>
          <td style="text-align: center">776</td>
        </tr>
        <tr id="r222">
          <td style="text-align: center">221</td>
          <td>特立尼达和多巴哥</td>
          <td style="overflow: hidden">TrinidadandTobago</td>
          <td style="overflow: hidden">theRepublicofTrinidadandTobago</td>
          <td>TT</td>
          <td>TTO</td>
          <td style="text-align: center">780</td>
        </tr>
        <tr id="r223">
          <td style="text-align: center">222</td>
          <td>突尼斯</td>
          <td>Tunisia</td>
          <td style="overflow: hidden">theRepublicofTunisia</td>
          <td>TN</td>
          <td>TUN</td>
          <td style="text-align: center">788</td>
        </tr>
        <tr id="r224">
          <td style="text-align: center">223</td>
          <td>土耳其</td>
          <td>
            <font class="font4">Türkiye</font>
            <font class="font5"> [7]</font>
          </td>
          <td style="overflow: hidden">
            <font class="font4">theRepublicofTürkiye</font>
            <font class="font5"> [7]</font>
          </td>
          <td>TR</td>
          <td>TUR</td>
          <td style="text-align: center">792</td>
        </tr>
        <tr id="r225">
          <td style="text-align: center">224</td>
          <td>土库曼斯坦</td>
          <td style="overflow: hidden">Turkmenistan</td>
          <td>/</td>
          <td>TM</td>
          <td>TKM</td>
          <td style="text-align: center">795</td>
        </tr>
        <tr id="r226">
          <td style="text-align: center">225</td>
          <td style="overflow: hidden">特克斯和凯科斯群岛</td>
          <td style="overflow: hidden">TurksandCaicosIslands(the)</td>
          <td>/</td>
          <td>TC</td>
          <td>TCA</td>
          <td style="text-align: center">796</td>
        </tr>
        <tr id="r227">
          <td style="text-align: center; height: 11.25pt">226</td>
          <td>图瓦卢</td>
          <td>Tuvalu</td>
          <td>/</td>
          <td>TV</td>
          <td>TUV</td>
          <td style="text-align: center">798</td>
        </tr>
        <tr id="r228">
          <td style="text-align: center">227</td>
          <td>乌干达</td>
          <td>Uganda</td>
          <td style="overflow: hidden">theRepublicofUganda</td>
          <td>UG</td>
          <td>UGA</td>
          <td style="text-align: center">800</td>
        </tr>
        <tr id="r229">
          <td style="text-align: center; height: 11.25pt">228</td>
          <td>乌克兰</td>
          <td>Ukraine</td>
          <td>/</td>
          <td>UA</td>
          <td>UKR</td>
          <td style="text-align: center">804</td>
        </tr>
        <tr id="r230">
          <td style="text-align: center">229</td>
          <td>阿联酋</td>
          <td style="overflow: hidden">UnitedArabEmirates(the)</td>
          <td style="overflow: hidden">theUnitedArabEmirates</td>
          <td>AE</td>
          <td>ARE</td>
          <td style="text-align: center">784</td>
        </tr>
        <tr height="81" style="height: 60.75pt" id="r231">
          <td height="77" style="text-align: center; height: 57.75pt">230</td>
          <td>英国</td>
          <td style="overflow: hidden">UnitedKingdom(the)</td>
          <td style="overflow: hidden">
            theUnitedKingdomofGreatBritainandNorthernIreland
          </td>
          <td>GB</td>
          <td>GBR</td>
          <td style="text-align: center">826</td>
        </tr>
        <tr id="r232">
          <td style="text-align: center">231</td>
          <td>美国</td>
          <td style="overflow: hidden">UnitedStates(the)</td>
          <td style="overflow: hidden">theUnitedStatesofAmerica</td>
          <td>US</td>
          <td>USA</td>
          <td style="text-align: center">840</td>
        </tr>
        <tr style="height: 48.75pt" id="r233">
          <td style="text-align: center; height: 45.75pt">232</td>
          <td>美国本土外小岛屿</td>
          <td style="overflow: hidden">
            UnitedStatesMinorOutlyingIslands(the)
          </td>
          <td>/</td>
          <td>UM</td>
          <td>UMI</td>
          <td style="text-align: center">581</td>
        </tr>
        <tr id="r234">
          <td style="text-align: center">233</td>
          <td>乌拉圭</td>
          <td>Uruguay</td>
          <td style="overflow: hidden">theEasternRepublicofUruguay</td>
          <td>UY</td>
          <td>URY</td>
          <td style="text-align: center">858</td>
        </tr>
        <tr id="r235">
          <td style="text-align: center">234</td>
          <td>乌兹别克斯坦</td>
          <td>Uzbekistan</td>
          <td style="overflow: hidden">theRepublicofUzbekistan</td>
          <td>UZ</td>
          <td>UZB</td>
          <td style="text-align: center">860</td>
        </tr>
        <tr id="r236">
          <td style="text-align: center">235</td>
          <td>瓦努阿图</td>
          <td>Vanuatu</td>
          <td style="overflow: hidden">theRepublicofVanuatu</td>
          <td>VU</td>
          <td>VUT</td>
          <td style="text-align: center">548</td>
        </tr>
        <tr id="r237">
          <td style="text-align: center">236</td>
          <td>委内瑞拉</td>
          <td>Venezuela</td>
          <td style="overflow: hidden">theBolivarianRepublicofVenezuela</td>
          <td>VE</td>
          <td>VEN</td>
          <td style="text-align: center">862</td>
        </tr>
        <tr id="r238">
          <td style="text-align: center">237</td>
          <td>越南</td>
          <td>VietNam</td>
          <td style="overflow: hidden">theSocialistRepublicofVietNam</td>
          <td>VN</td>
          <td>VNM</td>
          <td style="text-align: center">704</td>
        </tr>
        <tr id="r239">
          <td style="text-align: center">238</td>
          <td>英属维尔京群岛</td>
          <td style="overflow: hidden">VirginIslands(British)</td>
          <td style="overflow: hidden">BritishVirginIslands(the)</td>
          <td>VG</td>
          <td>VGB</td>
          <td style="text-align: center">92</td>
        </tr>
        <tr id="r240">
          <td style="text-align: center">239</td>
          <td>美属维尔京群岛</td>
          <td style="overflow: hidden">VirginIslands(U.S.)</td>
          <td style="overflow: hidden">theVirginIslandsoftheUnitedStates</td>
          <td>VI</td>
          <td>VIR</td>
          <td style="text-align: center">850</td>
        </tr>
        <tr id="r241">
          <td style="text-align: center">240</td>
          <td>瓦利斯和富图纳</td>
          <td style="overflow: hidden">WallisandFutuna</td>
          <td style="overflow: hidden">WallisandFutunaIslands</td>
          <td>WF</td>
          <td>WLF</td>
          <td style="text-align: center">876</td>
        </tr>
        <tr id="r242">
          <td style="text-align: center">241</td>
          <td>西撒哈拉</td>
          <td style="overflow: hidden">WesternSahara</td>
          <td>/</td>
          <td>EH</td>
          <td>ESH</td>
          <td style="text-align: center">732</td>
        </tr>
        <tr id="r243">
          <td style="text-align: center">242</td>
          <td>也门</td>
          <td>Yemen</td>
          <td style="overflow: hidden">theRepublicofYemen</td>
          <td>YE</td>
          <td>YEM</td>
          <td style="text-align: center">887</td>
        </tr>
        <tr id="r244">
          <td style="text-align: center">243</td>
          <td>赞比亚</td>
          <td>Zambia</td>
          <td style="overflow: hidden">theRepublicofZambia</td>
          <td>ZM</td>
          <td>ZMB</td>
          <td style="text-align: center">894</td>
        </tr>
        <tr id="r245">
          <td style="text-align: center">244</td>
          <td>津巴布韦</td>
          <td>Zimbabwe</td>
          <td style="overflow: hidden">theRepublicofZimbabwe</td>
          <td>ZW</td>
          <td>ZWE</td>
          <td style="text-align: center">716</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  text-align: center;
  padding: 8px;
  border: 1px solid #ccc;
}

th {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>
